import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const SwitchLeftPalm = ({
  showSwitchLeftAnimation,
  setShowSwitchLeftAnimation,
}: {
  showSwitchLeftAnimation: boolean;
  setShowSwitchLeftAnimation: (show: boolean) => void;
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!showSwitchLeftAnimation) {
      return;
    }
    const timer = setTimeout(() => {
      setShowSwitchLeftAnimation(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, [showSwitchLeftAnimation, setShowSwitchLeftAnimation]);

  if (!showSwitchLeftAnimation) {
    return null;
  }

  return (
    <div className="absolute top-0 left-0 right-0 bottom-0 bg-[#151714]/80 flex flex-col pt-10 pb-20 h-full items-center justify-center text-size-16 text-inverted gap-2">
      <div>{t("scan.rightPalmScanComplete")}</div>
      <div>{t("scan.proceedToLeftHand")}</div>
      <div className="w-3/4 h-1 relative bg-neutral-50/40 rounded-sm overflow-hidden max-w-[220px]">
        <div className="progress-animation h-1 left-[0.50px] top-0 absolute bg-[#3692CD] rounded-sm animate-progress" />
      </div>
    </div>
  );
};
